import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SeedPreparationResponse } from './seed.types';
import { Observable } from 'rxjs';

export const seedResolver: ResolveFn<SeedPreparationResponse> = (): Observable<SeedPreparationResponse> => {
  return inject(HttpClient).get<SeedPreparationResponse>('data-sync/prepare');
};
